import { BankPayoutForm } from "../Pages/BankPayouts";
export default function SellerOnboarding({ isOpen, onClose }) {
  if (!isOpen) return null;
  return (
    <div className="zy-profile-extras text-[#172831] dark:text-[#f3f6f8]">
      <div
        className="zy-modal fixed inset-0 z-[10000] grid place-items-center bg-black/50 p-4 md:p-5"
        role="dialog"
        aria-modal="true"
        aria-label="Bank and payouts"
      >
        <div className="zy-modal-content max-h-[90dvh] w-full max-w-[650px] overflow-y-auto overscroll-contain rounded-[20px] bg-white p-6 text-[#172831] dark:bg-[#23272c] dark:text-[#f3f6f8]">
          <div className="zy-between flex items-center justify-between gap-4 mb-5">
            <h2 className="text-xl font-extrabold">Bank & Payouts</h2>
            <button
              className="zy-button inline-flex min-h-11 cursor-pointer items-center justify-center gap-2 rounded-[14px] px-[17px] py-[11px] text-sm font-semibold disabled:cursor-wait disabled:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#49a3c9] border border-slate-200 bg-white dark:border-[#363e46] dark:bg-[#23272c] secondary"
              onClick={onClose}
            >
              Close
            </button>
          </div>
          <BankPayoutForm />
        </div>
      </div>
    </div>
  );
}
